import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Form, FormGroup, FormInput, Card, CardBody } from 'shards-react'

import Validate from '../../services/validate-service/Validate'
import withLoading from '../../hocs/withLoading/withLoading'

import './reset-password.css'

const FormReset = props => {
    const { email, setEmail, sendEmail } = props
    FormReset.propTypes = {
        sendEmail: PropTypes.func,
        email: PropTypes.string,
        setEmail: PropTypes.func,
    }

    return (
        <div className={'form-reset--container'}>
            <Card>
                <CardBody>
                    <Form onSubmit={sendEmail} style={{ marginBottom: '10px' }}>
                        <FormGroup>
                            <label htmlFor="email">
                                Insira seu email e enviaremos um link para você redefinir sua senha.
                            </label>
                            <FormInput
                                required
                                placeholder={'Digite seu email'}
                                name={'email'}
                                value={email}
                                valid={Validate.emailValidate(email)}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </FormGroup>
                        <Button block className={'form-auth--bt-login'}>
                            Enviar
                        </Button>
                    </Form>
                    <Link
                        style={{ display: 'block', textAlign: 'center' }}
                        to={{
                            pathname: '/',
                        }}
                    >
                        Voltar ao login
                    </Link>
                </CardBody>
            </Card>
        </div>
    )
}

const WrappedComponent = withLoading(FormReset)
export default WrappedComponent
